<template>

  <div>
    <Upload :accept="accept" :method="getFiles">
      <h5 class="my-4"><strong>Selecione ou arraste o seu<br>arquivo aqui</strong></h5>
    </Upload>

    <div v-if="files.length > 0">

      <div style="position: relative" class="ibox pb-2" v-for="file in files" :key="file.fileId">
        <XIcon class="icon" @click="removeFile(file.fileId)"/>
        <div class="ibox-content">
          {{ file.file.name }}
          <br>
          <span>{{ file.messages.join('; ') }}</span>
        </div>
        <div class="progress mt-2">
          <div class="content" :style="{width: `${file.percentage}%`}"></div>
        </div>
      </div>

    </div>

  </div>

</template>

<script>
  import Upload from '@/components/shares/specialTag/Upload'
  import { XIcon } from 'vue-feather-icons'

  export default {
    components: { Upload, XIcon },
    data() {
      return {
        fileId: 0,
        files: [],
      }
    },
    methods: {
      addFile(file) {
        this.files.push({
          file: file,
          fileId: this.fileId ++,
          messages: '',
          percentage: 0,
          status: null,
          uploaded: false
        })
      },
      getFiles(files) {
        files.forEach(file => this.addFile(file))
        this.startUpload()
      },
      removeFile(fileId) {
        this.files = this.files.filter(file => file.fileId !== fileId)
      },
      startUpload() {
        let files = this.files.filter(file => file.status === null)

        const extensions = this.accept.split(',').map(t => t.trim())
        files.forEach(file => {
          if (!extensions.some(ext => file.file.name.endsWith(ext))) {
            file.messages = ['Extensão inválida']
            file.status = 'invalid'
          } else if (file.file.size > this.maxFileSize) {
            file.messages = ['Limit máximo de 1Gb.']
            file.status = 'invalid'
          } else {
            file.messages = ['Enviando.']
            this.upload(file)
          }
        })
      },
      upload(file) {
        const headers = { 'Content-Type': 'multipart/form-data' }
        const formData = new FormData()
        formData.append('archive', file.file)

        const onUploadProgress = (progressEvent)  => {
          file.percentage = Math.round((progressEvent.loaded * 100) / progressEvent.total)
        }

        const success = () => {
          file.messages = ['Arquivo importado com sucesso e está sendo processado.']
          file.status = 'ok'
        }

        const error = e => {
          file.messages = e.errors || ['Erro ao tenta fazer o Upload']
          file.status = 'invalid'
        }

        this.axios.post('archives', formData, { headers, onUploadProgress })
          .then(success)
          .catch(error)
      }
    },
    name: 'UploadArchive',
    props: {
      accept: { default: '.xml,.XML,.zip' }
    }
  }
</script>

<style scoped>
  .progress {
    height: 5px;

    background: red;
    border-radius: 4px;
    margin: 0 16px;
  }

  .progress > .content {
    height: 5px;

    background: #FFD953;
    border-radius: 4px 0px 0px 4px;
  }

  .icon {
    position: absolute;
    right: 8px;
    top: 8px;
    cursor: pointer;
  }

</style>
